import { BitrixVue } from 'ui.vue';

/*
 * теперь этот файл/поток будет кодироваться в UTF-8
 */

BitrixVue.component('Color', {
	data() {
		return {};
	},
	props: ['state', 'color'],
	template: `
	<div class="config-color__item" @click="$emit('setActiveColor')" :title="color?.title ? color.title : ''">
			<div class="config-color__img" v-if="color.type==='image'">
					<img v-if="color.value" :src="color.value" :alt="color.title">
					<img v-else :src="color.image" :alt="color.title">
			</div>
			<div class="config-color__img" v-else>
					<img v-if="color.value" :src="color.value" :alt="color.title">
					<img v-else :src="color.image" :alt="color.title">
			</div>
			<div class="config-color__color" v-else :style="{backgroundColor: color.value}"></div>
			<div class="config-color__title" v-if="color?.title">{{color.title}}</div>
			<div class="config-color__name" v-if="color.price">+ {{color.price}} руб</div>
	</div>
`,
});
